import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/monthly/2.png'
import _imports_1 from '../../assets/monthly/3.png'
import _imports_2 from '../../assets/monthly/4.png'
import _imports_3 from '../../assets/monthly/5.png'
import _imports_4 from '../../assets/monthly/6.png'
import _imports_5 from '../../assets/monthly/7.png'
import _imports_6 from '../../assets/index_dzl.png'
import _imports_7 from '@/assets/Frame1.png'
import _imports_8 from '@/assets/Frame2.png'
import _imports_9 from '@/assets/Frame3.png'
import _imports_10 from '@/assets/bvlv_blue.png'


const _hoisted_1 = { style: {"background":"#FFF"} }
const _hoisted_2 = {
  style: {"width":"100%","margin":"0 auto","background":"#FFF","position":"relative"},
  class: "ccc"
}
const _hoisted_3 = {
  class: "img",
  style: {"padding-left":"33px","padding-top":"80px"}
}
const _hoisted_4 = { style: {"color":"#FFFFFF","font-size":"33.33px","font-weight":"700"} }
const _hoisted_5 = { style: {"color":"#FFFFFF","font-size":"12.5px","font-weight":"400","margin-top":"10px"} }
const _hoisted_6 = {
  class: "",
  style: {"display":"flex","align-items":"center","column-gap":"20px","margin-top":"77px"}
}
const _hoisted_7 = {
  class: "g",
  style: {"position":"relative","display":"flex","align-items":"center","gap":"3.33px","border-radius":"6.67px","background":"#ffffff40","width":"83px","cursor":"pointer","height":"27px","line-height":"27px","justify-content":"center"}
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  class: "",
  style: {"margin-top":"17px","display":"flex","flex-direction":"column","row-gap":"10px"}
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "",
  style: {"width":"50px","height":"50px","border-radius":"12px"}
}
const _hoisted_12 = {
  key: 0,
  style: {"width":"50px","height":"50px","border-radius":"12px"},
  src: _imports_2
}
const _hoisted_13 = {
  key: 1,
  style: {"width":"50px","height":"50px","border-radius":"12px"},
  src: _imports_3
}
const _hoisted_14 = {
  key: 2,
  style: {"width":"50px","height":"50px","border-radius":"12px"},
  src: _imports_4
}
const _hoisted_15 = {
  key: 3,
  style: {"width":"50px","height":"50px","border-radius":"12px","color":"#7c7c7c","font-size":"13.33px","font-weight":"900","position":"relative"}
}
const _hoisted_16 = { style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"} }
const _hoisted_17 = { style: {"display":"flex","column-gap":"10px","flex":"1"} }
const _hoisted_18 = { style: {"position":"relative","height":"101px","width":"180px","background":"#666","border-radius":"8px"} }
const _hoisted_19 = ["src"]
const _hoisted_20 = { style: {"position":"absolute","bottom":"12px","left":"10px","right":"10px","color":"#ffffff"} }
const _hoisted_21 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_22 = {
  key: 0,
  style: {"display":"flex","align-items":"center","column-gap":"13px"}
}
const _hoisted_23 = { style: {"font-size":"10px","color":"#ffffff","display":"flex","align-items":"center","column-gap":"4px"} }
const _hoisted_24 = { style: {"font-size":"10px","color":"#ffffff","display":"flex","align-items":"center","column-gap":"4px"} }
const _hoisted_25 = {
  key: 1,
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { style: {"font-size":"10px","color":"#ffffff","display":"flex","align-items":"center","column-gap":"4px"} }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { style: {"font-size":"10px","color":"#ffffff","display":"flex","align-items":"center","column-gap":"4px"} }
const _hoisted_30 = { style: {"color":"#ffffff","font-size":"10px","font-weight":"400"} }
const _hoisted_31 = { style: {"flex":"1"} }
const _hoisted_32 = { style: {"color":"#333333","font-size":"16.67px","font-weight":"700"} }
const _hoisted_33 = { style: {"margin-top":"8px"} }
const _hoisted_34 = { style: {"color":"#333333","font-size":"14px"} }
const _hoisted_35 = { style: {"display":"flex","align-items":"center","column-gap":"10px","margin-top":"28px"} }
const _hoisted_36 = { style: {"width":"20px","height":"20px"} }
const _hoisted_37 = ["src"]
const _hoisted_38 = { style: {"font-size":"14px","display":"flex","align-items":"center","column-gap":"10px"} }
const _hoisted_39 = { style: {"margin-right":"5px","font-size":"11.67px"} }
const _hoisted_40 = {
  key: 3,
  style: {"display":"flex","justify-content":"center","padding":"0.1rem 0"}
}
const _hoisted_41 = { class: "wVC_list_l_T_B_rz" }
const _hoisted_42 = { style: {"display":"flex","align-center":"center","row-gap":"7px","flex-direction":"column","justify-content":"center","text-align":"center","border-left":"1px solid #E5E6EB","padding-left":"20px"} }
const _hoisted_43 = { style: {"color":"#c01a26","font-size":"20px","font-weight":"700"} }
const _hoisted_44 = {
  key: 0,
  style: {"padding-bottom":"20px","padding-top":"20px","display":"flex","justify-content":"flex-end","align-items":"center","width":"100%"}
}
const _hoisted_45 = {
  class: "",
  style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}
}
const _hoisted_46 = { class: "" }
const _hoisted_47 = { style: {"margin-top":"16px"} }
const _hoisted_48 = { style: {"border":"1px solid  #E5E6EB","border-radius":"8px","height":"45px","width":"100%","line-height":"45px","text-align":"left","margin-top":"8px","color":"#000000","padding-left":"12px"} }
const _hoisted_49 = { style: {"display":"inline-block","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"454px"} }

import { ref, nextTick } from "vue"
import { Axios } from "../../assets/js/ls_com_axios.js";
import ShadowIndexAllWorks from "../ShadowIndexAllWorks/ShadowIndexAllWorks.vue";
import allProduction from "@/views/ShadowActivity/allProduction.vue";
import QRCode from 'qrcode'
import getsignatureInfo from "../../wx/index.js";
import img____ from "../../assets/fx.png"
import useClipboard from 'vue-clipboard3'
import { ElMessage } from "element-plus"
import { useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let params = new URLSearchParams(location.search);
const qrcodeCanvas = ref<any>(null)
const idDetail = ref({});
const list = ref([]);
const loading = ref(false);
const isShowShare_ = ref(false);
const fxxx = ref(location.href);
const queryParams = ref({
    pageNum: 1,
    pageSize: 10,
    total: 0
});
const data_monthly = ref({});
const idList = () => {
    let res = Axios("get", "/system/rangking/info", {
        id: params.get("id")
    }, false, function (res: any) {
        if (res.data.code == 200) {
            idDetail.value = res.data.data;
            getsignatureInfo({
                url: encodeURIComponent(fxxx.value),
                title: res.data.data.listName,
                desc: res.data.data.listContent,
                imgUrl: img____
            })
        } else {
            ElMessage.error(res.data.msg || "查询失败");
        }
    })
}
const getList = () => {
    let url = params.get("listSource") == 1 ? '/material/material/work/listAll' : params.get("listSource") == 2 ? '/fodder/manage/list' : "/system/activity-join/offlineList"
    let data = params.get("listSource") == 1 ? {
        listId: params.get("id"),
        condition: {},
        endTime: null,
        startTime: null,
        keyWord: null,
        time: null,
        pageIndex: queryParams.value.pageNum,
        pageSize: queryParams.value.pageSize
    } : params.get("listSource") == 2 ? {
        materialType: "VIDEO",
        // orderByColumn: "createTime",
        // isAsc: "desc",
        submitStatus: 1,
        listId: params.get("id"),
        pageNum: queryParams.value.pageNum,
        pageSize: queryParams.value.pageSize
    } : {
        pageNum: queryParams.value.pageNum,
        pageSize: queryParams.value.pageSize,
        userName: "",
        auditStatus: 0,
        activityId: "",
        listId: params.get("id"),
    }
    loading.value = true;
    let res = Axios(params.get("listSource") == 1 ? "post" : "get", url, data, false, function (res: any) {
        if (res.data.code == 200) {
            list.value = [];
            queryParams.value.total = params.get("listSource") == 1 ? res.data.data.total : res.data.total;
            const list_ = params.get("listSource") == 1 ? res.data.data.records : res.data.rows;
            if (params.get("listSource") == 4) {
                list_ = list_.map((item) => {
                    return {
                        ...item,
                        showImage: item.imagesOther ? JSON.parse(item.imagesOther)[0].url : "",
                    }
                })
            }
            list.value = list_.map((item: any) => {
                return {
                    ...item,
                    userInfo: {}
                }
            })
            for (let i = 0, item; item = list_[i]; i++) {
                getInfo__(params.get("listSource") == 1 ? item.createUserId : params.get("listSource") == 2 ? item.createUser : item.memberId, i, list_);
            }
        }
        loading.value = false;
    }, function (name) {
        loading.value = false;
    })
}
const { toClipboard } = useClipboard()
const copyBtn = async () => {
    await toClipboard(location.href);
    ElMessage.success("复制成功");
    isShowShare_.value = false
}
const route = useRoute();
const getQrCode = function () {
    let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 1,
        margin: 2,
        width: 200,
        height: 200,
        text: route.fullPath,
        color: {
            light: '#fff'
        }
    }
    QRCode.toCanvas(qrcodeCanvas.value, window.location.href, opts, function (error: any) { if (error) console.info(error) });
}
const share = () => {
    isShowShare_.value = true;
    nextTick(() => {
        getQrCode()
        if (!!qrcodeCanvas.value) {
            let ctx = qrcodeCanvas.value.getContext('2d')
            let image = new Image()
            image.crossOrigin = 'Anonymous'
            image.src = 'qrcodelogo.png'
            image.onload = () => {
                ctx.drawImage(image, 75, 75, 50, 50)
            }
        }
    })
}
let getInfo__ = function (id: any, index: number) {
    Axios(
        "GET",
        "/member/info/" + id,
        false,
        false,
        function (res: any) {
            (list.value as any)[index]['userInfo'] = res.data.data;
        });
};
getList()
const CertificationCenter = () => {
    open("/AuthenTicationHome", "_blank");
};
const cancel = () => {
    data_monthly.value = {}
}
const paginationChange = (num: number) => {
    queryParams.value.pageNum = num;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    getList()
}
idList()
const onclickBtn = (item) => {
    if (params.get("listSource") == 2) {
        return open("/ShadowMaterialVideoParticulars?id=" + item.id, "_blank");
    }
    data_monthly.value = item;
}

return (_ctx: any,_cache: any) => {
  const _component_VideoPlay = _resolveComponent("VideoPlay")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(idDetail.value.listName), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(idDetail.value.listContent), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            onClick: share,
            style: {"display":"flex","align-items":"center","gap":"3.33px","border-radius":"6.67px","background":"#FFF","width":"60px","cursor":"pointer","height":"27px","line-height":"27px","justify-content":"center"}
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { style: {} }, [
              _createElementVNode("img", {
                style: {"width":"13px","height":"13px"},
                src: _imports_0
              })
            ], -1),
            _createElementVNode("div", { style: {"font-weight":"400","color":"#c01a26","font-size":"11.67px"} }, [
              _createElementVNode("span", null, "分享")
            ], -1)
          ])),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { style: {} }, [
              _createElementVNode("img", {
                style: {"width":"13px","height":"13px"},
                src: _imports_1
              })
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"font-weight":"400","color":"#FFFFFF","font-size":"11.67px"} }, [
              _createElementVNode("span", null, "规则说明")
            ], -1)),
            (idDetail.value.rule)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: idDetail.value.rule,
                  class: "s",
                  style: {"position":"absolute","top":"40px","left":"0","background":"#FFF","box-shadow":"0 3.33px 10px 0 #8991a140","padding":"10px","border-radius":"6.67px","width":"416.67px","height":"auto","z-index":"9999"}
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (onclickBtn(item)),
            class: "",
            key: item.id,
            style: {"display":"flex","align-items":"center","column-gap":"10px","cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_11, [
              (queryParams.value.pageNum == 1 && index == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (queryParams.value.pageNum == 1 && index == 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : (queryParams.value.pageNum == 1 && index == 2)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                          style: {"width":"50px","height":"50px","border-radius":"12px"},
                          src: _imports_5
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(queryParams.value.pageNum == 1 ? index + 1 : (queryParams.value.pageNum - 1) * queryParams.value.pageSize +
                                index + 1), 1)
                      ]))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: _unref(params).get('listSource') == 1 ? item.coverSheet : item.showImage,
                  style: {"width":"180px","height":"101px","border-radius":"8px"}
                }, null, 8, _hoisted_19),
                _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"position":"absolute","top":"12px","right":"10px","width":"30px","background":"#33333380","padding":"1.67px 5px","border-radius":"3.33px","color":"#ffffff","font-size":"9.33px","font-weight":"400"} }, [
                  _createElementVNode("span", null, "高清")
                ], -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_unref(params).get('listSource') == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_el_icon, { style: {"font-size":"13px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VideoPlay)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(item.plays), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _cache[5] || (_cache[5] = _createElementVNode("img", {
                              style: {"width":"13px","height":"13px"},
                              src: _imports_6
                            }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(item.likes), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(params).get('listSource') == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                      : _createCommentVNode("", true),
                    (_unref(params).get('listSource') == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_el_icon, { style: {"font-size":"13px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VideoPlay)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(item.playCount || 0), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(params).get('listSource') == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_el_icon, { style: {"font-size":"20px","vertical-align":"middle"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Picture)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(item.playCount || 0), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", null, _toDisplayString(_unref(params).get('listSource') == 1 ? item.videoTime : item.playTime), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", null, _toDisplayString(_unref(params).get('listSource') == 4 ? item.imagesOther ?
                                JSON.parse(item.imagesOther).map(item => item.title).join('-') : "" : item.title), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"color":"#c01a26","font-size":"14px"} }, "上榜理由：", -1)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(item.listReason), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("img", {
                      src: item.userInfo.avatar ? item.userInfo.avatar : require('../../assets/logo.png'),
                      alt: "",
                      style: {"width":"100%","height":"100%","border-radius":"50%"},
                      srcset: ""
                    }, null, 8, _hoisted_37)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(item.userInfo.nickName), 1),
                    (item.userInfo.realStatus == 2)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"height":"0.16rem","vertical-align":"middle","margin-top":"-2px"},
                          onClick: CertificationCenter,
                          src: _imports_7,
                          title: "实名认证"
                        }))
                      : _createCommentVNode("", true),
                    (item.userInfo.enterpriseStatus == 2)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          style: {"height":"0.16rem","vertical-align":"middle","margin-top":"-2px"},
                          onClick: CertificationCenter,
                          src: _imports_8,
                          title: "企业认证"
                        }))
                      : _createCommentVNode("", true),
                    (item.userInfo.unionStatus == 2)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          style: {"height":"0.16rem","vertical-align":"middle","margin-top":"-2px"},
                          onClick: CertificationCenter,
                          src: _imports_9,
                          title: "联盟认证"
                        }))
                      : _createCommentVNode("", true),
                    (item.userInfo.professionalStatus == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[8] || (_cache[8] = _createElementVNode("img", { src: _imports_10 }, null, -1)),
                            _createTextVNode(" 标识山西认证" + _toDisplayString(item.userInfo.profess), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"color":"#333333","font-size":"11.67px"} }, [
                  _createElementVNode("span", null, "上榜次数")
                ], -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", null, _toDisplayString(item.listNum), 1)
                ])
              ])
            ])
          ], 8, _hoisted_10))
        }), 128))
      ]),
      (list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createVNode(_component_el_pagination, {
              total: queryParams.value.total,
              "current-page": queryParams.value.pageNum,
              onCurrentChange: paginationChange,
              "page-size": queryParams.value.pageSize
            }, null, 8, ["total", "current-page", "page-size"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(params).get('listSource') == 1 && Object.keys(data_monthly.value).length)
      ? (_openBlock(), _createBlock(ShadowIndexAllWorks, {
          key: 0,
          type: "no",
          data_monthly: data_monthly.value,
          onCancel: cancel
        }, null, 8, ["data_monthly"]))
      : _createCommentVNode("", true),
    ((_unref(params).get('listSource') == 3 || _unref(params).get('listSource') == 4) && Object.keys(data_monthly.value).length)
      ? (_openBlock(), _createBlock(allProduction, {
          key: 1,
          type: "no",
          data_monthly: data_monthly.value,
          onCancel: cancel
        }, null, 8, ["data_monthly"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: isShowShare_.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowShare_).value = $event)),
      "show-close": true,
      "close-on-click-modal": false,
      title: "分享",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("canvas", {
              ref_key: "qrcodeCanvas",
              ref: qrcodeCanvas
            }, null, 512)
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "",
            style: {"color":"#333333","font-size":"14px"}
          }, " 扫描二维码，分享内容 ", -1))
        ]),
        _createElementVNode("div", _hoisted_47, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"color":"#333333","font-size":"14px"} }, [
            _createElementVNode("span", null, "分享榜单链接")
          ], -1)),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("span", _hoisted_49, _toDisplayString(fxxx.value), 1)
          ])
        ]),
        _createElementVNode("div", {
          onClick: copyBtn,
          style: {"background":"#2978FF","border-radius":"12px","height":"45px","width":"100%","text-align":"center","line-height":"45px","color":"#FFF","margin-top":"8px","cursor":"pointer"}
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("span", null, "复制链接", -1)
        ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})